<template>
  <div class="flex items-center">
    <vs-avatar :src="photoUrl" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link>
  </div>
</template>

<script>
export default {
  computed: {
    url () {
      return `lessons/${this.params.data.id}`
    },
    photoUrl () {
      return this.params.data.thumbnail !== null ? this.params.data.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
    }
  }
}
</script>
